import(/* webpackMode: "eager" */ "/opt/script/frontend/senegaljoogjob/src/app/service/service.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/script/frontend/senegaljoogjob/src/components/errorHandler/ClientErrorHandler.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/script/frontend/senegaljoogjob/src/components/serviceCardItem/ServiceCardItem.js");
